<template>
  <TheLoader :active="true"/>
</template>

<script>
import ObjektService from '@/services/ObjektService'

export default {
  name: 'ObjektFinder',
  data () {
    return {
      objektnr: null
    }
  },
  created () {
    this.objektnr = this._.trim((this.$route.params.objektnr || ''))

    if (!this.objektnr || !this.objektnr.match(/^\d+-\d+$/)) {
      this.onError()
    } else {
      ObjektService.sendObjektToElastic(this.objektnr)
        .then(response => {
          const item = response.data.item || null

          if (!item || !item.kontrakt) {
            throw new Error('Invalid item')
          }

          this.$router.push({
            name: 'KundeCard',
            params: { kunde_id: item.kontrakt.Kundenr },
            query: { kontrakt: item.kontrakt.Kontraktnr, objekt: item.Objektid },
            hash: ''
          })
        })
        .catch(error => {
          console.log(error)
          this.onError()
        })
    }
  },
  methods: {
    onError: function () {
      this.$helpers.showErrorAlert('Feil', 'Objektnr "' + (this.objektnr || 'null') + '" ikke funnet')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ObjektFinder.vue